import { AccessCodeMapper } from 'mapper/AccessCodeMapper';

export const accessCodeMapper = new AccessCodeMapper();
